"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 py-24">
      <div className="max-w-md mx-auto text-center">
        <h2 className="text-2xl font-bold tracking-tight">
          {t("errorPage.title")}
        </h2>
        <p className="mt-2 text-muted-foreground">
          {t("errorPage.description")}
        </p>
        {process.env.NODE_ENV === "development" && (
          <div className="mt-4 p-4 bg-gray-100 rounded-md text-start overflow-auto">
            <p className="text-sm font-mono text-red-500">{error.message}</p>
            <pre className="mt-2 text-xs whitespace-pre-wrap">
              {error.stack}
            </pre>
          </div>
        )}
        <div className="mt-6 flex items-center justify-center gap-4">
          <Button asChild>
            <Link href="/">{t("notFound.backHome")}</Link>
          </Button>
          <Button variant="outline" onClick={reset}>
            {t("common.retry")}
          </Button>
        </div>
      </div>
    </div>
  );
}
